import { createFileRoute } from '@tanstack/react-router';

import { ProviderDetailPage } from '@frontend/features/providers/components/ProviderDetailPage';

export const Route = createFileRoute('/provider-network/provider/$providerId/')(
  {
    component: ProviderDetailPage,
  },
);
